import { Box, Link, Paper, Skeleton, Stack, Typography } from '@mui/material'
import { ArrowForwardIos, PlayCircleOutline } from '@mui/icons-material'
import { useEffect, useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { CallsService } from '../../services/calls.service'
import { useError } from '../../context/error'
import { PastCall } from '../../_types/pastcall.type'

function formatDate(d: string): string {
  const date = new Date(d)
  if (Number.isNaN(date.getTime())) return d
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

export default function RecentCalls() {
  const { setError } = useError()
  const callsService = new CallsService(setError)

  const [calls, setCalls] = useState<PastCall[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    callsService.searchCalls(1).then(res => {
      if (cancelled) return
      const docs: PastCall[] = res?.docs ?? []
      setCalls(docs.slice(0, 9))
      setLoading(false)
    })
    return () => { cancelled = true }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Paper elevation={3} sx={{ p: 2, height: '100%' }}>
      <Box display='flex' alignItems='center' justifyContent='space-between' mb={1}>
        <Typography variant='h6'>Recent Calls</Typography>
        <RouterLink to='/calls' style={{ textDecoration: 'none' }}>
          <Typography
            variant='caption'
            color='primary'
            sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}
          >
            View all <ArrowForwardIos sx={{ fontSize: 10 }} />
          </Typography>
        </RouterLink>
      </Box>

      {loading ? (
        Array.from({ length: 3 }).map((_, i) => (
          <Box key={i} mb={1}>
            <Skeleton variant='text' width='30%' />
            <Skeleton variant='text' width='90%' />
          </Box>
        ))
      ) : calls.length === 0 ? (
        <Typography variant='body2' color='text.secondary'>No recent calls.</Typography>
      ) : (
        <Stack spacing={1.25}>
          {calls.map(c => (
            <Box key={c.id}>
              <Box display='flex' alignItems='center' justifyContent='space-between'>
                <Typography variant='subtitle2' fontWeight={600}>
                  {formatDate(c.date)}
                </Typography>
                {c.recordingLink && (
                  <Link
                    href={c.recordingLink}
                    target='_blank'
                    rel='noopener noreferrer'
                    underline='hover'
                    sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, fontSize: 13 }}
                  >
                    <PlayCircleOutline fontSize='small' /> Watch
                  </Link>
                )}
              </Box>
              {c.summary && (
                <Typography
                  variant='body2'
                  color='text.secondary'
                  sx={{
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden'
                  }}
                >
                  {c.summary}
                </Typography>
              )}
            </Box>
          ))}
        </Stack>
      )}
    </Paper>
  )
}
